import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Minimal unauthenticated chrome for the two public legal pages (mentions
// légales, politique de confidentialité). Mirrors LoginPage's branding
// (logo + wordmark, neutral-50 canvas) without the split-panel login UI.
export function PublicLegalShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-dvh bg-neutral-50 px-4 py-8 sm:py-12">
      <div className="mx-auto w-full max-w-[760px]">
        <header className="flex items-center justify-between mb-6">
          <Link to="/login" className="flex items-center gap-3">
            <img
              src="/brand/logo.jpg"
              alt="Le Prestigieux"
              className="h-9 w-9 object-contain rounded"
            />
            <div>
              <p className="text-[14px] font-bold text-neutral-950 leading-tight">PrestiX</p>
              <p className="text-[11px] text-neutral-500 leading-tight">Le Prestigieux</p>
            </div>
          </Link>
          <Link
            to="/login"
            className="flex items-center gap-1.5 text-[12px] font-medium text-neutral-500 hover:text-brand-gold-dark transition-colors"
          >
            <ArrowLeft size={13} />
            Retour à la connexion
          </Link>
        </header>

        {children}

        <footer className="mt-6 text-center text-[10.5px] text-neutral-400">
          Le Prestigieux - RCCM GA-LBV-01-2021-A10-00554 - Libreville, Gabon
        </footer>
      </div>
    </div>
  );
}
